import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";

const stats = [
  { value: "360°", label: "全视野穹顶银幕" },
  { value: "12.1", label: "声道环绕声场" },
  { value: "8K", label: "激光融合投影" },
  { value: "3", label: "专业穹顶放映厅" },
];

export default function BrandIntro() {
  return (
    <section className="max-w-content mx-auto px-4 md:px-8 py-16 md:py-24">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <Reveal>
          <div>
            <p className="text-xs font-label tracking-widest text-accent-500 uppercase mb-3">About Dome</p>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-5 leading-snug">
              不只是看电影，而是走进电影
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              球幕影院以半球形银幕与多机融合投影，将影像从地面延伸到头顶，
              消解传统银幕的边界感。观众不再是画面之外的旁观者，而是被完整包裹在故事之中。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
              我们与国内外制作团队合作，持续引进为穹顶空间专门绘制的沉浸式影像，
              让自然纪录、太空科幻与艺术叙事在同一个穹顶之下焕然一新。
            </p>
            <Link
              to="/technology"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-md border border-accent-500/60 text-accent-500 font-label hover:bg-accent-500/10 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-lightbulb-flash-line" />
              了解球幕技术
            </Link>
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div className="relative rounded-lg overflow-hidden aspect-[4/3] bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Interior%20of%20a%20modern%20futuristic%20dome%20cinema%20theater%20with%20a%20giant%20curved%20spherical%20screen%20glowing%20blue%2C%20tiered%20seating%20with%20soft%20amber%20lights%2C%20deep%20navy%20ambient%20tone%2C%20architectural%20photography%2C%20high%20detail%2C%20premium%20cinematic%20atmosphere&width=1200&height=900&seq=qiubu-intro-01&orientation=landscape"
              alt="球幕影院穹顶放映厅内部"
              title="球幕影院穹顶放映厅沉浸式环境"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-50/70 to-transparent" />
          </div>
        </Reveal>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-12">
        {stats.map((stat, i) => (
          <Reveal key={stat.label} delay={i * 80}>
            <div className="p-6 rounded-lg bg-background-100 border border-background-200/70 text-center h-full">
              <p className="font-heading font-bold text-2xl md:text-3xl text-accent-500 mb-2">{stat.value}</p>
              <p className="text-xs md:text-sm text-foreground-600">{stat.label}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}